import React, { Fragment } from "react";

const Navigation = ({ links = [], contentLink = null, iteration = 0 }) => {
  let menuRef = React.createRef();
  function toggleMenu() {
    menuRef.current.classList.toggle("navbar__menu--show");
    document.querySelector("body").classList.toggle("overlay");
  }
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const hasChildrenClass = links.length > 0 ? "has-children" : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;
  const firstLinks = links.filter((x) => !x.alternativeMenuObject);
  const secondLinks = links.filter((x) => x.alternativeMenuObject);
  var mouseOverMenu = false;

  const isMobile = () =>
    menuRef.current.classList.contains("navbar__menu--show");

  const handleOnMouseEnter = () => {
    // first navbar item, and not in mobile
    if (iteration == 0 && !isMobile())
      document.querySelector("body").classList.add("navbar-overlay");
  };

  const handleOnMouseLeave = () => {
    if (iteration == 0 && !isMobile() && !mouseOverMenu)
      document.querySelector("body").classList.remove("navbar-overlay");
  };

  const getMenuContent = () => (
    <>
      <div className="navbar__menu-header">
        {!contentLink ? (
          <span
            className="navbar__icon navbar__icon--close"
            onClick={toggleMenu}
          ></span>
        ) : (
          <Fragment>
            <i
              className="navbar__icon--caret-left navbar__icon"
              onClick={toggleMenu}
            ></i>
            <span
              className="navbar__title"
              onClick={toggleMenu}
              dangerouslySetInnerHTML={{ __html: contentLink.name }}
            ></span>
          </Fragment>
        )}
      </div>
      {links.length > 0 &&
        links.map(
          (link, i) =>
            hasNameOrChildren(link) && (
              <li
                className={
                  link.alternativeMenuObject
                    ? "navbar__item hidden-tablet-desktop"
                    : "navbar__item"
                }
                //Om fältet inte är tomt
                key={
                  !link.name
                    ? `${new Date().getTime()}-${i}`
                    : `${link.name}-${i}`
                }
              >
                <Navigation
                  links={link.links}
                  contentLink={link}
                  iteration={iteration + 1}
                />
              </li>
            )
        )}
    </>
  );
  return (
    <Fragment>
      {contentLink && (
        <Fragment>
          <a
            className={`navbar__link ${hasChildrenClass || ""} ${
              additionClass || ""
            }`}
            href={contentLink.url || "#"}
            target={contentLink.openNewTab ? "_blank" : "_self"}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
            style={{ color: `#${contentLink.mainMenuLinkColor}` }}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}
      {secondLinks.length > 0 && (
        <ul
          className="navbar__menu navbar__secondary-menu"
          ref={menuRef}
          test={secondLinks.length}
        >
          {secondLinks.length > 0 &&
            secondLinks.map(
              (link, i) =>
                hasNameOrChildren(link) && (
                  <li
                    className="navbar__item"
                    key={
                      !link.name
                        ? `${new Date().getTime()}-${i}`
                        : `${link.name}-${i}`
                    }
                  >
                    <Navigation
                      links={link.links}
                      contentLink={link}
                      iteration={iteration + 1}
                    />
                  </li>
                )
            )}
        </ul>
      )}
      {links.length > 0 && (
        <>
          {" "}
          {contentLink && contentLink.isFirst ? (
            <ul
              className="navbar__menu"
              ref={menuRef}
              test={links.length}
              onMouseEnter={() => (mouseOverMenu = true)}
              onMouseLeave={() => (mouseOverMenu = false)}
            >
              <div className="navbar__menu-content">{getMenuContent()}</div>
            </ul>
          ) : (
            <ul
              className="navbar__menu"
              ref={menuRef}
              test={links.length}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            >
              {getMenuContent()}
            </ul>
          )}{" "}
        </>
      )}
    </Fragment>
  );
};

export default Navigation;
